<template>
<section>
	<div class="count-wrap greenstyle">
		<div class="count-inner">
			<div class="count-text">一日所需能量</div>
			<countTo
				class="count-num" 
				:separator='theseparator' 
				:startVal='startVal' 
				:endVal='endVal' 
				:duration='2000'
			>
			</countTo>
			<div class="count-text">千卡</div>
		</div>
	</div>
	<div class="dayneed-result">
		<div class="result-text text-center">各餐配比</div>
		<div class="bili-wrap">
			<div class="bili-block bili-a">
				<div class="inner">
					<div class="bili-item bili1">
						<span>{{a * 2}}</span>千卡
					</div>
					<div class="bili-item bili2">
						<span>{{a * 2}}</span>千卡
					</div>
					<div class="bili-item bili3">
						<span>{{a}}</span>千卡
					</div>
				</div>
				<div class="bili-info">餐比A</div>
			</div>
			<div class="bili-block bili-b">
				<div class="inner">
					<div class="bili-item bili1">
						<span>{{b}}</span>千卡
					</div>
					<div class="bili-item bili2">
						<span>{{b}}</span>千卡
					</div>
					<div class="bili-item bili3">
						<span>{{b}}</span>千卡
					</div>
				</div>
				<div class="bili-info">餐比B</div>
			</div>
		</div>
	</div>
	<router-link to="/dayneedindex" class="calculate-link">返回首页</router-link>
</section>
</template>

<script>
import countTo from 'vue-count-to'

export default {
	components: {
		countTo
	},
	data () {
		return {
			startVal: 0,
			endVal: parseInt(this.$route.query.energy_required),
			theseparator:'',
			a:0,
			b:0
		}
	},
	head: {
		title: function () {
			return {
				inner: '一日所需能量',
				separator: ' ', 
        		complement: ' '
			}
		}
	},
	created(){
		this.a = this.endVal / 5
		this.b = Math.round(this.endVal / 3)
    }
}
</script>



// WEBPACK FOOTER //
// dayneedresult.vue?7e793b4a